var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-progress',{class:['progress', _vm.type],attrs:{"type":_vm.type,"percentage":_vm.percentage,"color":_vm.customColor,"width":48}})
}
var staticRenderFns = []

export { render, staticRenderFns }